import { ORDER_COLUMN, STATE_COLUMN, ACTION_COLUMN } from '../constant'
import { computed, provide, ref } from 'vue'
import { useUserStore } from '@/store/modules/user'
import { useDictStore } from '@/store/modules/dict'
import { MD5 } from 'crypto-js'
import { isAuth } from '@/directive/permission'
export default config => {
  const userStore = useUserStore()
  const dictStore = useDictStore()
  const primaryKey = MD5(`${userStore.userId}${config.title}`).toString()
  provide('primaryKey', primaryKey)
  const columnsKey = `${primaryKey}/columns`
  provide('columnsKey', columnsKey)
  const checksKey = `${primaryKey}/checks`
  provide('checksKey', checksKey)
  const columns = ref<any[]>(JSON.parse(window.localStorage.getItem(columnsKey) ?? '[]'))
  const checks = ref<string[]>(JSON.parse(window.localStorage.getItem(checksKey) ?? '[]'))
  const stateVisible = !!config.enableAction && !!config.disableAction
  const orderVisible = computed(() => (!!config.orderAction && config.orderAction?.permission ? isAuth(config.orderAction?.permission) : false))
  const columnsShow = computed(() => columns.value.filter(item => checks.value.includes(item.dataIndex)))
  const formatItem = item => {
    item.titleText = item.title
    if (item.customTitle) {
      item.title = item.customTitle
    }
    if (item.isDict) {
      item.customRender = ({ text }) => {
        return text ? dictStore.word.get(text)?.label : ''
      }
    }
  }
  const initColumns = () => {
    if (columns.value.length > 0) {
      const _columnsMap = {}
      config.columns.forEach(item => {
        const { form, ..._item } = item
        _columnsMap[item.dataIndex] = _item
      })
      columns.value = columns.value.map(item => {
        formatItem(item)
        return { ...item, ..._columnsMap[item.dataIndex] }
      })
      return
    }
    for (let i = 0; i < config.columns.length; ++i) {
      const { form, ...item } = config.columns[i]
      if (item.extra) continue
      if (item.sorter && config?.enableMutipleSort) {
        item.sorter = {
          multiple: i
        }
      }
      formatItem(item)
      // if (typeof item.width === 'number') {
      //   item.resizable = true
      //   item.minWidth = item.width / 2
      //   item.maxWidth = item.width * 2
      // }
      columns.value.push(item)
    }
    if (stateVisible) columns.value.push({ ...STATE_COLUMN, titleText: STATE_COLUMN.title })
    if (orderVisible.value) columns.value.push({ ...ORDER_COLUMN, titleText: ORDER_COLUMN.title })
    if (!config.isActionHidden) columns.value.push({ ...ACTION_COLUMN, width: config.actionWidth ?? 150, titleText: ACTION_COLUMN.title } as any)
  }
  const initChecks = () => {
    if (checks.value.length > 0) return
    for (let i = 0; i < columns.value.length; ++i) {
      const item = columns.value[i]
      checks.value.push(item.dataIndex)
    }
  }
  const resetColums = () => {
    window.localStorage.removeItem(columnsKey)
    window.localStorage.removeItem(checksKey)
    columns.value = []
    checks.value = []
    initColumns()
    initChecks()
  }
  initColumns()
  initChecks()
  return {
    columns,
    columnsShow,
    checks,
    resetColums
  }
}
